import { ProductV2 } from '@common'
import cx from 'classnames'

import { CardRibbon } from './CardRibbon'

import styles from './productRibbon.module.scss'

interface Props {
  product: ProductV2
  style?: 'red' | 'yellow' | 'turqoise' | 'darkBlue' | 'black'
  position?: 's'
  className?: string
}

function calculatePoints(product: ProductV2) {
  const pennies = product.prices?.['USD-US']
  if (!pennies) return undefined
  return Math.ceil(pennies / 2)
}

export const ProductRibbon = ({ product, position, className: additionalClasses }: Props) => {
  // const t = useTranslations() TODO: translation for 'pts'
  const pts = 'pts'
  const points = calculatePoints(product)
  const ribbonContent = points ? [`+${points} ${pts}`] : []

  // set style as black as per designs
  return (
    <div className={cx(styles.RibbonContainer, { [styles['position-s']]: position === 's' }, additionalClasses)}>
      <CardRibbon content={ribbonContent} style="black" compact />
    </div>
  )
}
